import { ERRORS } from '@/constants/error';
import { useAppContext } from '@/providers/app-provider/app-provider';
import { CategoryTree } from '@/types/category/category-get-tree';

const useCategoryTrees = () => {
  const context = useAppContext<{ categoryTrees: CategoryTree[] }>();
  if (!context.categoryTrees) {
    throw ERRORS.REGULAR('useCategoryTree must be passed to <Page/> context');
  }
  return context.categoryTrees;
};

export default useCategoryTrees;
